import React, { useState } from "react";
import { Badge } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import AdminAllRequestsPage from "./AdminAllRequestsPage";
import AdminPendingRequestsPage from "./AdminPendingRequestsPage";
import AdminCalendarPage from "./AdminCalendarPage";
import AdminBalancesPage from "./AdminBalancesPage";
import AdminBalanceHistoryPage from "./AdminBalanceHistoryPage";
import { useGetPendingAbsenceRequestsCountQuery } from "../../api/absenceRequestsApi";
import PageTitle from "../../components/common/PageTitle";
import TabbedPageCard from "../../components/common/TabbedPageCard";
import { AbsenceIcon } from "../../components/common/pageIcons";
import PageLayout from "../../components/layout/PageLayout";

const ABSENCE_TAB_INDEX: Record<string, number> = {
  requests: 0,
  pending: 1,
  calendar: 2,
  balances: 3,
  history: 4,
};

const AdminAbsencesPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { data: pendingCount = 0 } = useGetPendingAbsenceRequestsCountQuery();
  const [activeTab, setActiveTab] = useState(() => {
    const tab = searchParams.get("tab");
    return tab && tab in ABSENCE_TAB_INDEX ? ABSENCE_TAB_INDEX[tab] : 0;
  });

  const handleTabChange = (index: number) => {
    setActiveTab(index);
    if (index === 1) {
      setSearchParams({ tab: "pending" }, { replace: true });
    } else if (index === 2) {
      setSearchParams({ tab: "calendar" }, { replace: true });
    } else if (index === 3) {
      setSearchParams({ tab: "balances" }, { replace: true });
    } else if (index === 4) {
      setSearchParams({ tab: "history" }, { replace: true });
    } else {
      setSearchParams({}, { replace: true });
    }
  };

  return (
    <PageLayout variant="fullHeight">
      <PageTitle title="Absence Management" icon={<AbsenceIcon />} />
      <TabbedPageCard
        idPrefix="admin-absence"
        ariaLabel="absence management tabs"
        fullHeight
        selectedTab={activeTab}
        onTabChange={handleTabChange}
        tabs={[
          { id: "requests", label: "All Requests", content: <AdminAllRequestsPage /> },
          {
            id: "pending",
            label: (
              <Badge
                badgeContent={pendingCount}
                color="warning"
                sx={{ "& .MuiBadge-badge": { fontSize: "0.75rem" } }}
              >
                Pending
              </Badge>
            ),
            content: <AdminPendingRequestsPage />,
          },
          { id: "calendar", label: "Calendar", content: <AdminCalendarPage /> },
          { id: "balances", label: "Balances", content: <AdminBalancesPage /> },
          {
            id: "history",
            label: "Balance History",
            content: <AdminBalanceHistoryPage />,
          },
        ]}
      />
    </PageLayout>
  );
};

export default AdminAbsencesPage;
